import { ClientViewListRepresentationOutput } from '@coverright/data-access/types/enrollment';
import _ from 'lodash';

export const dataSource = (key: string, rows: ClientViewListRepresentationOutput[] = []) => (params: any): any => {
  const page = params?.variables?.pageInput;
  const searchTerm = params?.variables?.searchTerm;
  const tags = params?.variables?.includedTagsIds || [];

  let data = rows ? [...rows] : rows;

  if (searchTerm) {
    data = data?.filter(c => (
      [(c.firstName || ''), (c.lastName || ''), c.email].join(' ').trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
    ))
  }
  if (tags.length) {
    data = data?.filter(c => (
      _.intersection(c.tags.map(t => t.tag.id), tags).length
    ))
  }

  const pageRows = data.slice(page?.page * page?.size, (page?.page + 1) * page?.size);

  return {
    data: {
      [key]: {
        totalElements: data.length,
        data: pageRows,
      }
    },
    loading: !rows,
    previousData: []
  }
}
